import React from "react";

export default function PrivacyPolicy() {
  const APP_NAME = "Plin-ko GO";
  const DEVELOPER_NAME = "Zidalmal.Rafik";
  const sections = [
    {
      title: "Data We Collect",
      body: (
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li>Device details (model, OS, screen size, language)</li>
          <li>Advertising identifiers (GAID) with your OK</li>
          <li>App-generated ID for saving settings</li>
          <li>Analytics IDs (e.g., Firebase) for usage trends</li>
          <li>Push token if notifications are enabled</li>
          <li>Install source info (Play Store referrer)</li>
          <li>Crash reports (stack traces, app version)</li>
        </ul>
      ),
    },
    {
      title: "Why We Use It",
      body: (
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li>Keep the game running smoothly</li>
          <li>Restore your progress and preferences</li>
          <li>Improve features based on usage</li>
          <li>Measure campaign success (with consent)</li>
          <li>Deliver chosen notifications</li>
          <li>Detect abuse and fix bugs</li>
          <li>Follow legal requirements</li>
        </ul>
      ),
    },
    {
      title: "Data Sharing",
      body: (
        <p className="text-sm">
          We never sell your info. We only share with:
          <ul className="list-disc list-inside mt-1 space-y-1">
            <li>Analytics partners (e.g., Firebase)</li>
            <li>Ad platforms (e.g., Google Ads)</li>
            <li>Cloud hosts (e.g., AWS, GCP)</li>
            <li>Notification services</li>
            <li>Authorities, if legally required</li>
          </ul>
        </p>
      ),
    },
    {
      title: "Your Choices",
      body: (
        <p className="text-sm">
          You can manage consent for analytics and ads in the app’s settings or
          revoke push permissions any time via your device.
        </p>
      ),
    },
    {
      title: "Security & Retention",
      body: (
        <p className="text-sm">
          We encrypt data in transit (HTTPS). We keep it only as long as needed
          or as required by law. Aggregated stats may be stored longer.
        </p>
      ),
    },
    {
      title: "Your Rights",
      body: (
        <ul className="list-disc list-inside space-y-1 text-sm">
          <li>View the data we hold on you</li>
          <li>Request corrections</li>
          <li>Ask for deletion</li>
          <li>Withdraw consent</li>
          <li>Object to certain uses</li>
        </ul>
      ),
    },
    {
      title: "Children’s Privacy",
      body: (
        <p className="text-sm">
          This app is not for children under 13. If we unknowingly collect from
          a child, we’ll delete it on request.
        </p>
      ),
    },
    {
      title: "Policy Updates",
      body: (
        <p className="text-sm">
          We may revise this notice. When we do, we’ll update the “Last updated”
          date at the top.
        </p>
      ),
    },
    {
      title: "Contact Us",
      body: (
        <p className="text-sm">
          For questions or data requests, contact us at:
          <br />
          Zidalmal.Rafik
          <br />
          <a
            href="mailto:privacy@example.com"
            className="text-blue-400 underline"
          >
            Email: zidalmalrafik@gmail.com
          </a>
          .
        </p>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 px-4 py-8">
      <div className="max-w-sm mx-auto space-y-6">
        <header className="text-center">
          <h1 className="text-3xl font-bold">Privacy Notice for {APP_NAME}</h1>
        </header>

        <section className="bg-gray-800 rounded-lg border border-gray-700 p-4">
          <h2 className="text-xl font-semibold">Introduction</h2>
          <p>
            Welcome to {APP_NAME} (the "App"), provided by {DEVELOPER_NAME}{" "}
            ("we," "us," or "our"). This Privacy Policy explains how we collect,
            use, share, and protect information obtained from users ("you") of
            our App. Your privacy is important to us, and we are committed to
            being transparent about our data practices.
          </p>
          <p>
            By installing and using the App, you acknowledge that you have read
            and understood this Privacy Policy. Where required by law, we will
            obtain your explicit consent for specific data processing
            activities.
          </p>
        </section>

        {sections.map(({ title, body }) => (
          <details
            key={title}
            open
            className="bg-gray-800 rounded-lg border border-gray-700 p-4"
          >
            <summary className="font-semibold cursor-pointer text-lg">
              {title}
            </summary>
            <div className="mt-2">{body}</div>
          </details>
        ))}
      </div>
    </div>
  );
}
